import { render, staticRenderFns } from "./ExamineList.vue?vue&type=template&id=f2f81db2&scoped=true&"
import script from "./ExamineList.vue?vue&type=script&lang=js&"
export * from "./ExamineList.vue?vue&type=script&lang=js&"
import style0 from "./ExamineList.vue?vue&type=style&index=0&id=f2f81db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f81db2",
  null
  
)

export default component.exports